// extracted by mini-css-extract-plugin
module.exports = {"FuturePanePreset":"FuturePanePreset__FuturePanePreset__PzDZz"};